












































































































import { Component, Vue } from "vue-property-decorator";

import { moveGroup } from "@/move-group";

import { ILottoTicket } from "@/interface";
import { MTGSetType } from "@/enum";

@Component({
    name: "SettingsRange",
    props: {
        header: String,
        unit: String,
        value: Number,
        start: Number,
        end: Number,
        steps: Number,
        tofixedParam: Number,
        displayDividedBy: Number,
    },
})
export default class SettingsRange extends Vue {

    private tickets: ILottoTicket[] | undefined;
    private value: number | undefined;
    private unit: string | undefined;
    private displayDividedBy: number | undefined;
    private tofixedParam: number | undefined;
    private displayValue: string = "";

    public beforeMount() {
        this.updateDisplay(this.value);
    }

    public newValue(event: Event): void {
        if (event && event.target instanceof HTMLInputElement) {
            const newValue = event.target.valueAsNumber;
            this.$emit("change", newValue);
            this.updateDisplay(newValue);
        }
    }

    public updateDisplay(newValue?: number): void {
        const displayDividedBy = this.displayDividedBy ? this.displayDividedBy : 1;
        if (typeof newValue === "number") {
            const setValue = newValue / displayDividedBy;
            if (setValue === 0 && this.unit === "FPS") {
                this.displayValue = "ಠ_ಠ";
            } else {
                this.displayValue = `${ setValue.toFixed(this.tofixedParam) } ${ this.unit }`;
            }
        }
    }

    public moveGroup(ev: KeyboardEvent): void {
        return moveGroup(ev);
    }
}
